"use client";

import React from "react";

const ProductDescription = ({ product }) => {
  // If no product or no description data, don't render anything
  if (!product || !product.descriptionData || product.descriptionData.length === 0) {
    return null;
  }

  const descriptionItems = product.descriptionData;

  // Color schemes for alternating cards
  const colorSchemes = [
    { bg: "bg-blue-50", text: "text-blue-800" },
    { bg: "bg-yellow-50", text: "text-yellow-800" },
    { bg: "bg-gray-50", text: "text-gray-800" },
    { bg: "bg-green-50", text: "text-green-800" },
    { bg: "bg-purple-50", text: "text-purple-800" },
    { bg: "bg-red-50", text: "text-red-800" },
  ];

  return (
    <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-6 lg:py-4">
      <h1 className="text-4xl md:text-5xl lg:text-5xl tracking-wide leading-snug text-neutral-700 font-bold text-center max-md:max-w-full mb-8">
        Product Description
      </h1>

      <div className="space-y-3 md:space-y-4 lg:space-y-6">
        {descriptionItems.map((item, index) => {
          const colorScheme = colorSchemes[index % colorSchemes.length];
          const isEven = index % 2 === 0;
          const hasImage = item.image && item.image.trim() !== '';

          return (
            <div key={index} className={`grid grid-cols-1 w-full ${hasImage ? 'lg:grid-cols-3' : 'lg:grid-cols-1'} gap-6 lg:gap-8 items-stretch`}>
              {/* Image - Only render if image exists */}
              {hasImage && (
                <div className={`lg:col-span-1 relative aspect-square rounded-2xl overflow-hidden shadow-xl border border-gray-200 bg-gray-50 order-1 ${isEven ? 'lg:order-1' : 'lg:order-2'}`}>
                  <img
                    src={item.image}
                    alt={item.title || 'Product description image'}
                    className="absolute inset-0 w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
              )}

              {/* Description - Full width when no image, 2 columns when image exists */}
              <div className={`${hasImage ? 'lg:col-span-2' : 'lg:col-span-1'} ${colorScheme.bg} rounded-2xl p-6 lg:p-10 flex flex-col justify-center items-center shadow-lg order-2 ${hasImage && !isEven ? 'lg:order-1' : 'lg:order-2'}`}>
                {item.title && (
                  <h3 className={`text-2xl md:text-3xl font-bold ${colorScheme.text} mb-4 text-center`}>
                    {item.title.charAt(0).toUpperCase() + item.title.slice(1)}
                  </h3>
                )}
                {item.content && (
                  <p className="text-gray-700 text-base md:text-lg leading-relaxed text-center">
                   {item.content.charAt(0).toUpperCase() + item.content.slice(1)}
                  </p>
                )}
                {!item.title && !item.content && (
                  <p className="text-gray-500 text-base md:text-lg leading-relaxed italic text-center">
                    No description available for this item.
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProductDescription;
